export default function () {
  return {
    list: [],
    latestClientVersion: null,
    swupdateUrl: null
  }
}
